import { render, staticRenderFns } from "./VentasMercancias.vue?vue&type=template&id=608c9d7e&"
import script from "./VentasMercancias.vue?vue&type=script&lang=js&"
export * from "./VentasMercancias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports